import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Loader } from '../../Common/Loader'
import Table from '../../Common/Table'
import { getuserTransationByid } from '../../service/service'


const WithdrawalReports = () => {
    const [loader, setLoader] = useState(false)
    const [dateSelect, setDateSelect] = useState(moment().format("YYYY-MM-DD"))
    const [withdrawList, setWithdrawList] = useState([])

    useEffect(() => {
        handleGetWithdrawList(moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD"))
    }, [])

    const handleGetWithdrawList = (start_date, end_date) => {
        setLoader(true)
        getuserTransationByid(null, start_date, end_date).then((res) => {
            setWithdrawList(res.data?.data)
            setLoader(false)
        }).catch((err) => {
            setLoader(false)
            alert(err || "something went wrong ")
        })
    }

    const handleAllTime = () => {
        setDateSelect("")
        handleGetWithdrawList()
    }

    const totalAmount   = withdrawList?.reduce((s, i) => s + (parseFloat(i?.amount) || 0), 0)
    const approvedAmount = withdrawList?.filter(i => i?.is_rejected === 'APPROVE').reduce((s, i) => s + (parseFloat(i?.amount) || 0), 0)
    const rejectedAmount = withdrawList?.filter(i => i?.is_rejected === 'REJECT').reduce((s, i) => s + (parseFloat(i?.amount) || 0), 0)
    const pendingAmount  = withdrawList?.filter(i => i?.is_rejected === 'PENDING').reduce((s, i) => s + (parseFloat(i?.amount) || 0), 0)

    return (
        <>
            {loader ? <Loader /> : null}
            <div className="content-wrapper">
                <div className='container-fluid'>
                    <div className='card p-3 flex align-center space-between mb-3'>
                        <h4 className="card-title text-left w-100">Withdraw Fund Request List</h4>
                        <div className='row w-100'>
                            <div className='form-group col-md-3'>
                                <input type="date" id="start" className='form-control' value={dateSelect} onChange={(e) => {
                                    setDateSelect(e.target.value)
                                }} />
                            </div>
                            <div className='form-group col-md-2'>
                                <button type="button" className="btn btn-danger btn-block" onClick={() => handleGetWithdrawList(dateSelect, dateSelect)}>Submit</button>
                            </div>
                            <div className='form-group col-md-2'>
                                <button type="button" className="btn btn-secondary btn-block" onClick={handleAllTime}>All Time</button>
                            </div>
                        </div>
                    </div>
                    <div className='row mb-3'>
                        <div className='col-md-3'>
                            <div className='card p-3 text-center' style={{borderLeft:'4px solid #6c757d'}}>
                                <div style={{fontSize:'16px',color:'#6c757d',fontWeight:'600'}}>TOTAL REQUESTS</div>
                                <div style={{fontSize:'22px',fontWeight:'700'}}>₹{totalAmount.toFixed(2)}</div>
                                <div style={{fontSize:'14px',color:'#888'}}>{withdrawList?.length} requests</div>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className='card p-3 text-center' style={{borderLeft:'4px solid #28a745'}}>
                                <div style={{fontSize:'16px',color:'#28a745',fontWeight:'600'}}>APPROVED</div>
                                <div style={{fontSize:'22px',fontWeight:'700',color:'#28a745'}}>₹{approvedAmount.toFixed(2)}</div>
                                <div style={{fontSize:'14px',color:'#888'}}>{withdrawList?.filter(i => i?.is_rejected === 'APPROVE').length} request(s)</div>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className='card p-3 text-center' style={{borderLeft:'4px solid #f8b400'}}>
                                <div style={{fontSize:'16px',color:'#f8b400',fontWeight:'600'}}>REJECTED</div>
                                <div style={{fontSize:'22px',fontWeight:'700',color:'#f8b400'}}>₹{rejectedAmount.toFixed(2)}</div>
                                <div style={{fontSize:'14px',color:'#888'}}>{withdrawList?.filter(i => i?.is_rejected === 'REJECT').length} request(s)</div>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className='card p-3 text-center' style={{borderLeft:'4px solid #ffc107'}}>
                                <div style={{fontSize:'16px',color:'#e6a800',fontWeight:'600'}}>PENDING</div>
                                <div style={{fontSize:'22px',fontWeight:'700',color:'#e6a800'}}>₹{pendingAmount.toFixed(2)}</div>
                                <div style={{fontSize:'14px',color:'#888'}}>{withdrawList?.filter(i => i?.is_rejected === 'PENDING').length} request(s)</div>
                            </div>
                        </div>
                    </div>
                    <Table
                        list={withdrawList}
                        getInformation={handleGetWithdrawList}
                        head="Withdraw Fund Request List"
                    />
                </div>
            </div>
        </>
    )
}

export default WithdrawalReports


